import { FunctionComponent, ReactNode } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper';
import Oven from '@elem/SVGIcon/VanlifeRoadtrips/Oven';
import Dryer from '@elem/SVGIcon/Homebattery/Dryer';
import CanPower from '../canPower';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EFLight from '@/components/UI/svg/LandingPage/EFLight';
import EFWifiRouter from '@/components/UI/svg/LandingPage/EFWifiRouter';
import EFPhone from '@/components/UI/svg/LandingPage/EFPhone';
import EFLaptop from '@/components/UI/svg/LandingPage/EFLaptop';
import EFRefrigerator from '@/components/UI/svg/LandingPage/EFRefrigerator';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import EFMicroware from '@/components/UI/svg/LandingPage/EFMicroware';
import EFElectricKettle from '@/components/UI/svg/LandingPage/EFElectricKettle';
import EFCoffeeMaker from '@/components/UI/svg/LandingPage/EFCoffeeMaker';
import EFAirConditioner from '@/components/UI/svg/LandingPage/EFAirConditioner';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/');
interface PropsType {
    id: string;
}
const StarterKit: FunctionComponent<PropsType> = (props) => {
    const { useLang, gtm, useRouter } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const canPowerList =
        locale === 'ca'
            ? [
                  {
                      name: t('secF_Light'),
                      times: `16 days`,
                      icon: <EFLight />,
                  },
                  {
                      name: t('secF_WiFiRouter'),
                      times: `18 days`,
                      icon: <EFWifiRouter />,
                  },
                  {
                      name: '50" TV',
                      times: `108 hr`,
                      icon: (
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M20.901 5.23242C21.7004 5.23242 22.3484 5.88038 22.3484 6.67975V17.3012C22.3484 18.0182 21.7672 18.5994 21.0501 18.5994L15.0169 18.5989V20.2024L17.2358 20.2027C17.4567 20.2027 17.6358 20.3818 17.6358 20.6027C17.6358 20.8016 17.4907 20.9665 17.3006 20.9975L17.2358 21.0027H6.76311C6.5422 21.0027 6.36311 20.8237 6.36311 20.6027C6.36311 20.4039 6.50817 20.239 6.69823 20.208L6.76311 20.2027L8.98089 20.2024V18.5989L3.09771 18.5994C2.33641 18.5994 1.71244 18.0117 1.65474 17.2652L1.65039 17.1521V6.67975C1.65039 5.88038 2.29835 5.23242 3.09771 5.23242H20.901ZM14.2171 18.599H9.78087V20.2025H14.2171V18.599ZM20.901 6.03242H3.09771C2.74018 6.03242 2.45039 6.32221 2.45039 6.67975V17.1521C2.45039 17.5096 2.74018 17.7994 3.09771 17.7994H21.0501C21.3253 17.7994 21.5484 17.5764 21.5484 17.3012V6.67975C21.5484 6.32221 21.2586 6.03242 20.901 6.03242ZM19.7005 7.2302C19.9214 7.2302 20.1005 7.40929 20.1005 7.6302V16.2016C20.1005 16.4225 19.9214 16.6016 19.7005 16.6016H4.27193C4.05102 16.6016 3.87193 16.4225 3.87193 16.2016V7.6302C3.87193 7.40929 4.05102 7.2302 4.27193 7.2302H19.7005ZM19.2999 8.03002H4.67187V15.8015H19.2999V8.03002Z"
                                  fill="#fff"
                              />
                          </svg>
                      ),
                  },
                  {
                      name: t('secF_Refrigerator'),
                      times: `4-8 days`,
                      icon: <EFRefrigerator />,
                  },
                  {
                      name: t('secF_ElectricKettle'),
                      times: `8.8 hr`,
                      icon: <EFElectricKettle />,
                  },
                  {
                      name: t('secF_ElectricHeater'),
                      times: `6 hr`,
                      icon: <EFElectricHeater />,
                  },
                  {
                      name: 'Electric Oven',
                      times: `8 hr`,
                      icon: <Oven className="w" />,
                  },
                  {
                      name: 'Microwave',
                      times: `10 hr`,
                      icon: <EFMicroware />,
                  },
                  {
                      name: t('secF_AirConditioner'),
                      times: `7.2-14.4 hr`,
                      icon: <EFAirConditioner />,
                  },
                  {
                      name: 'Clothes Dryer',
                      times: `2.8 hr`,
                      icon: <Dryer className="w" />,
                  },
              ]
            : [
                  {
                      name: t('secF_Light'),
                      times: `4 ${t('secF_days')}`,
                      icon: <EFLight />,
                  },
                  {
                      name: t('secF_phone'),
                      times: `143 ${t('secF_times')}`,
                      icon: <EFPhone />,
                  },
                  {
                      name: t('secF_Refrigerator'),
                      times: `13 ${t('secF_hrs')}`,
                      icon: <EFRefrigerator />,
                  },
                  {
                      name: t('secF_Microwave'),
                      times: `1.3 ${t('secF_hrs')}`,
                      icon: <EFMicroware />,
                  },
                  {
                      name: t('secF_CoffeeMaker'),
                      times: `1.6 ${t('secF_hrs')}`,
                      icon: <EFCoffeeMaker />,
                  },
                  {
                      name: t('secF_WiFiRouter'),
                      times: `4 ${t('secF_days')}`,
                      icon: <EFWifiRouter />,
                  },
                  {
                      name: t('secF_laptop'),
                      times: `26 ${t('secF_times')}`,
                      icon: <EFLaptop />,
                  },
                  {
                      name: t('secF_ElectricHeater'),
                      times: `0.7 ${t('secF_hrs')}`,
                      icon: <EFElectricHeater />,
                  },
                  {
                      name: t('secF_ElectricKettle'),
                      times: `1.1 ${t('secF_hrs')}`,
                      icon: <EFElectricKettle />,
                  },
                  {
                      name: t('secF_AirConditioner'),
                      times: `0.9 ${t('secF_hrs')}`,
                      icon: <EFAirConditioner />,
                  },
              ];
    const buyNow = () => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: t('delta_pro_whole_home.solution4_device'),
                position: `Solution Page_${t('delta_pro_whole_home.solution4_name')}`,
            });
            // fb埋点
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(
            locale === 'ca'
                ? 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384730266'
                : `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station?variant=40539815673929`,
            '_blank',
        );
    };

    return (
        <div className={css.starterKit} id={props.id}>
            <div className="content">
                <div className="swiper">
                    <Swiper
                        modules={[Autoplay, Pagination]}
                        className="solution-swiper starterkit-swiper"
                        pagination={{
                            clickable: true,
                        }}
                        navigation={false}
                        initialSlide={0}
                        autoplay={true}
                        loop
                        speed={800}
                        spaceBetween={10}
                        centeredSlides={true}
                    >
                        <SwiperSlide>
                            <div className="img-box">
                                <EfImg
                                    className="img1"
                                    pc="https://websiteoss.ecoflow.com/upload/image/1723023615450/%E5%9C%BA%E6%99%AF-%E7%99%BD%E5%A4%A9.jpg"
                                />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className="img-box">
                                <EfImg className="img2" pc="https://websiteoss.ecoflow.com/upload/image/1723023664330/DP3%2BSHP%20(1).png" />
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
                <div className="info-box">
                    <div className="name">{'Smart Control Kit'}</div>
                    <div className="device">{'EcoFlow DELTA Pro 3 + Smart Home Panel 2'}</div>
                    <div className="power">
                        {
                            '- Expands from 4-48kWh for up to 1 week of power\n- Automatic 20 ms switchover time for uninterrupted power*\n- Smart energy management with the EcoFlow app\n- Avoid peak power rates to lower energy bills'
                        }
                    </div>
                    <div className="desc">
                        {
                            'Uninterrupted backup power supply and smart power management. Take control of your energy and reduce your electricity bills with stored energy'
                        }
                    </div>
                </div>
                <div className="buy-box">
                    <div className="buy-btn" onClick={() => buyNow()}>
                        {t('buy_now')}
                    </div>
                </div>
                <CanPower list={canPowerList} />
            </div>
        </div>
    );
};

export default StarterKit;
